import {Roles} from "@/config/RoleOptions";
import API from '@/services/API';
import router from '@/router';
import { intersection } from "lodash-es";
const api = API();
const apiNoIntercept = API({ baseURL: '/api/' }, false);

const auth = {
    namespaced: true,
    state: {
        authenticated: null,
    },
    mutations: {
        setCurrentUser(state, { user }) {
            state.authenticated = user;
        },
        resetCurrentUser(state) {
            state.authenticated = null;
        }
    },
    actions: {
        setCurrentUser(context, { user }) {
            context.commit('setCurrentUser', { user });
        },
        async getCurrentUser(context, intercept = true) {
            // Already have a cached user (no need to call the API)
            if (context.state.authenticated) {
                return context.state.authenticated;
            }

            try {
                // Otherwise we get the user, intercept is to avoid infinite redirections when needed
                const response = intercept ? await api.get('users/profile') : await apiNoIntercept.get('users/profile');
                await context.dispatch('setCurrentUser', { user: response.data.data });
                return response.data.data;
            } catch (error) {
                await context.dispatch('setCurrentUser', { user: null });
                // Email is not verified redirecting to verification page
                if (error.response.status === 406) {
                    router.replace({ name: "VerificationNotice"});
                    return error;
                }
                return null;
            }

        },
        resetCurrentUser(context) {
            if (window.Intercom) {
                window.Intercom('shutdown');
            }
            context.commit('resetCurrentUser');
        },
        async fetchAndSetCurrentUser(context) {
            const response = await api.get('users/profile');
            await context.dispatch('setCurrentUser', { user: response.data.data });
        }
    },
    getters: {
        user(state) {
            return state.authenticated;
        },
        userId(state) {
            return state.authenticated ? state.authenticated.id : state.authenticated;
        },
        isBeta(state) {
            return intersection(state.authenticated?.roles, [Roles.BETA_USER, Roles.SUPER_ADMIN, Roles.BETA_OWNER]).length > 0;
        }
    }
}

export default auth;
